export default "__VITE_ASSET__e0c12361__"